import { useState, useEffect, useRef, useCallback } from 'react';
import { useT, THEME, pastelBtn } from './UI';
import { useStore } from '../store';

const token = () => localStorage.getItem('ri_token');
const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() });

function coincideTelefono(a, b) {
  if (!a || !b) return false;
  return a === b || a.endsWith(b) || b.endsWith(a);
}

function paraEnviar(telefono) {
  const d = (telefono || '').replace(/\D/g, '');
  return d.length === 9 ? '34' + d : d;
}

export default function WhatsAppChat() {
  const theme = useT();
  const { data } = useStore();
  const [conversaciones, setConversaciones] = useState([]);
  const [activo, setActivo] = useState(null);
  const [mensajes, setMensajes] = useState([]);
  const [input, setInput] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [waStatus, setWaStatus] = useState(null);
  const [waQrTs, setWaQrTs] = useState(0);
  const [waReconectando, setWaReconectando] = useState(false);
  const chatRef = useRef(null);
  const activoRef = useRef(null);

  const fetchWaStatus = useCallback(async () => {
    try {
      const r = await fetch('http://192.168.0.24:3010/status');
      setWaStatus(await r.json());
    } catch {
      setWaStatus({ ok: false, status: 'sin respuesta' });
    }
  }, []);

  useEffect(() => {
    fetchWaStatus();
    const iv = setInterval(fetchWaStatus, 4000);
    return () => clearInterval(iv);
  }, [fetchWaStatus]);

  async function reconectarWa() {
    setWaReconectando(true);
    try {
      await fetch('http://192.168.0.24:3010/reconectar', { method: 'POST' });
      setWaQrTs(Date.now());
      setTimeout(fetchWaStatus, 1500);
    } catch {}
    setWaReconectando(false);
  }

  const cargarConversaciones = useCallback(async () => {
    try {
      const r = await fetch('/api/whatsapp-inbox/conversaciones', { headers: authHeaders() });
      setConversaciones(await r.json());
    } catch {}
  }, []);

  useEffect(() => {
    cargarConversaciones();
    const iv = setInterval(cargarConversaciones, 10000);
    return () => clearInterval(iv);
  }, [cargarConversaciones]);

  useEffect(() => {
    activoRef.current = activo;
    if (!activo) { setMensajes([]); return; }
    const cargarHilo = async () => {
      try {
        const r = await fetch(`/api/whatsapp-inbox/mensajes/${encodeURIComponent(activo)}`, { headers: authHeaders() });
        const rows = await r.json();
        if (activoRef.current === activo) setMensajes(rows);
      } catch {}
    };
    cargarHilo();
    const iv = setInterval(cargarHilo, 4000);
    return () => clearInterval(iv);
  }, [activo]);

  useEffect(() => {
    const el = chatRef.current;
    if (!el) return;
    const cercaDelFondo = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
    if (cercaDelFondo) el.scrollTop = el.scrollHeight;
  }, [mensajes]);

  function nombrePara(telefono) {
    const c = (data.clientes || []).find(x => coincideTelefono((x.telefono || '').replace(/\D/g, ''), telefono));
    return c ? c.nombre : (telefono || 'Desconocido');
  }

  async function enviar() {
    if (!input.trim() || !activo || enviando) return;
    if (!/^\d+$/.test(activo)) return alert('No se puede responder a este chat (número no identificado).');
    setEnviando(true);
    try {
      const r = await fetch('/api/whatsapp/texto', {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ to: paraEnviar(activo), message: input.trim() }),
      });
      const d = await r.json();
      if (d.ok === false) alert('❌ ' + (d.error || 'Error al enviar'));
      else setInput('');
    } catch (e) { alert('❌ ' + e.message); }
    setEnviando(false);
  }

  return (
    <div>
      <div style={{
        ...pastelBtn(theme, waStatus?.ok ? 'green' : 'red'),
        borderRadius:10, padding:'10px 14px', marginBottom:12, fontSize:13,
      }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
          <span>
            {waStatus === null ? 'Comprobando sesión de WhatsApp...'
              : waStatus.ok ? '✓ WhatsApp conectado'
              : `✗ WhatsApp ${waStatus.status || 'desconectado'}. No se pueden enviar ni recibir mensajes.`}
          </span>
          {waStatus && !waStatus.ok && (
            <button type="button" onClick={reconectarWa} disabled={waReconectando}
              style={{ ...pastelBtn(theme,'red'), borderRadius:6, padding:'4px 10px', fontSize:12, fontWeight:600, cursor:'pointer' }}>
              {waReconectando ? 'Generando...' : '📱 Generar código QR'}
            </button>
          )}
        </div>
        {waStatus && !waStatus.ok && waQrTs > 0 && (
          <div style={{ marginTop:10 }}>
            <div style={{ fontSize:12, marginBottom:6 }}>Escanea con WhatsApp → Dispositivos vinculados:</div>
            <img src={`http://192.168.0.24:3010/qr?t=${waQrTs}`} alt="QR WhatsApp"
              style={{ width:220, height:220, border:`1px solid ${pastelBtn(theme,'red').color}`, borderRadius:8, background:'#fff', padding:8 }}
              onError={e => { e.target.style.display='none'; }} />
          </div>
        )}
      </div>
    <div style={{ display: 'flex', height: 'calc(100vh - 110px)', gap: 16 }}>
      <div style={{ width: 300, flexShrink: 0, background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, overflowY: 'auto' }}>
        {conversaciones.map(c => (
          <button key={c.telefono || c.jid} onClick={() => setActivo(c.telefono || c.jid)}
            style={{
              display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', border: 'none',
              borderBottom: `1px solid ${theme.border}`, cursor: 'pointer', fontFamily: 'inherit',
              background: activo === (c.telefono || c.jid) ? theme.primaryBg : 'transparent',
            }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: theme.ink }}>{nombrePara(c.telefono)}</div>
            <div style={{ fontSize: 12, color: theme.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {c.from_me ? 'Tú: ' : ''}{c.mensaje}
            </div>
          </button>
        ))}
        {conversaciones.length === 0 && <div style={{ padding: 20, color: theme.muted, fontSize: 13 }}>Sin conversaciones todavía.</div>}
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: 'hidden' }}>
        {!activo ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: theme.muted }}>
            Selecciona una conversación
          </div>
        ) : (
          <>
            <div style={{ padding: '12px 16px', borderBottom: `1px solid ${theme.border}`, fontWeight: 700, color: theme.ink }}>
              {nombrePara(activo)} <span style={{ fontWeight: 400, color: theme.muted, fontSize: 12 }}>({activo})</span>
            </div>
            <div ref={chatRef} style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {mensajes.map(m => (
                <div key={m.msg_id} style={{ display: 'flex', flexDirection: 'column', alignItems: m.from_me ? 'flex-end' : 'flex-start' }}>
                  <div style={{
                    maxWidth: '70%', padding: '8px 13px', fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.5,
                    borderRadius: m.from_me ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                    background: m.from_me ? theme.primary : theme.surface2,
                    color: m.from_me ? (theme === THEME.dark ? '#0b0b09' : '#fff') : theme.ink,
                    fontStyle: m.tipo !== 'texto' ? 'italic' : 'normal',
                    opacity: m.tipo !== 'texto' ? 0.75 : 1,
                  }}>
                    {m.mensaje}
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8, padding: 12, borderTop: `1px solid ${theme.border}` }}>
              <input value={input} onChange={e => setInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && !e.shiftKey && enviar()}
                placeholder="Escribe un mensaje..." disabled={enviando}
                style={{ flex: 1, padding: '9px 14px', borderRadius: 20, border: `1px solid ${theme.borderStrong}`, background: theme.surface, color: theme.ink, outline: 'none', fontSize: 13 }} />
              <button onClick={enviar} disabled={enviando || !input.trim()}
                style={{ padding: '9px 20px', borderRadius: 20, background: theme.primary, color: theme === THEME.dark ? '#0b0b09' : '#fff', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: 13, opacity: enviando || !input.trim() ? .5 : 1 }}>
                Enviar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
    </div>
  );
}
